const USER_TOKEN: string = "__A__T__";
const isDev: boolean = process.env.NODE_ENV === 'development';
const isProd: boolean = process.env.NODE_ENV === 'production';

export {
  USER_TOKEN,
  isDev,
  isProd,
};
